import React from 'react';
import { AdvancedMarker } from '@vis.gl/react-google-maps';

const GPXMarker = ({ position, onClick, active }) => {
  return (
    <AdvancedMarker position={position} onClick={onClick} zIndex={active ? 3 : 1}>
      <div
        style={{
          width: '5px',
          height: '5px',
          borderRadius: '50%',
          backgroundColor: '#2196F3',
          border: '1.5px solid white',
          boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
          cursor: 'pointer',
          transform: active ? 'scale(1.8)' : 'scale(1)',
          transition: 'transform 0.2s ease',
        }}
      />
    </AdvancedMarker>
  );
};

export default GPXMarker;
